import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect } from "react";

const styles = {
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100vw",
    maxWidth: "100%",
  },
};

function Loading(props) {
  const { llm } = props;
  const [count, setCount] = React.useState(0);
  const loadText = ["Outlining a draft", "Writing prompts", "Painting images", "Animating videos", "Herding zebras", "Reprimanding winged monkeys", "Adjusting style", "Thawing servers", "This whole thing should take < 2 mins", "A man walked into a bar", "Ouch", "Engaging models", "Vibe coding backend", "Tipping agents", "Should be done soon", "No really soon", "Balancing spreadsheets", "Wrestling robots", "Check back in a minute"];

  useEffect(() => {
    if (llm) {
      const interval = setInterval(() => {
        setCount((count) => (count + 1) < loadText.length ? count + 1 : count);
        if(count + 1 === loadText.length) clearInterval(interval);
      }, 7000);
    }
  }, [llm]);

  return (
    <Box sx={styles.loader}>
      <CircularProgress />
      {llm && <Box sx={{marginLeft: '15px'}}>{loadText[count]}...</Box>}
    </Box>
  );
}

export default Loading;
